import React, { Component } from "react"
import FocusTrap from 'focus-trap-react'
import "./SlidingPanel.scss"

export default class SlidingPanel extends Component {
  state = {
    shadeAnimationClass: "fadeIn",
    sliderAnimationClass: "slideInRight",
    closing: false
  }
  closingCallback = null
  closeSlider = callback => {
    this.setState({
      shadeAnimationClass: "fadeOut",
      sliderAnimationClass: "slideOutRight",
      closing: true
    })
    this.closingCallback = callback
  }
  transitionOver = () => {
    if (this.state.closing) {
      this.setState({ closing: false })
      this.props.closeSlider()
      if (this.closingCallback) {
        this.closingCallback()
      }
    }
  }
  render() {
    const { children, closeOnShadeClick, ariaLabel } = this.props
    return (
      <aside className="sliding-panel-wrapper" aria-label={ariaLabel}>
        <FocusTrap
          focusTrapOptions={{ clickOutsideDeactivates: true }}
          className={
            "sliding-panel animated fast-animation " +
            this.state.sliderAnimationClass
          }
          id="sliding-panel-scrollable"
          role="dialog"
          aria-label="Your cart"
        >
          {children}
        </FocusTrap>
        <div
          className={
            "shade animated fast-animation " + this.state.shadeAnimationClass
          }
          onAnimationEnd={this.transitionOver}
          onClick={closeOnShadeClick !== false ? this.closeSlider : null}
        />
      </aside>
    )
  }
}
